const tintColorLight = '#2f95dc';
const tintColorDark = '#ffffff99';

export default {
  light: {
    text: 'black',
    background: 'white',
    tint: tintColorLight,
    tabIconDefault: '#ccc',
    tabIconSelected: tintColorLight,
    border: 'white',
    view: 'white'
  },
  dark: {
    text: 'white',
    background: 'black',
    tint: tintColorDark,
    tabIconDefault: '#ccc',
    tabIconSelected: tintColorDark,
  },
};
